"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverviewPage = exports.OverviewPageQuery = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const date_1 = require("../../../date");
const base_1 = require("../../device/class/base");
const common_1 = require("../../device/class/common");
const FleetCounters = __importStar(require("../../device/report/fleetCounters"));
const tenant_1 = require("../../tenant");
exports.NAMESPACE = 'Culligan.Api.Dashboard.Overview';
exports.OverviewPageQuery = effect_1.Schema.Struct({
    model: effect_1.Schema.optionalWith(effect_1.Schema.ArrayEnsure(common_1.ModelCode), { exact: true, default: () => [] }),
    status: effect_1.Schema.optionalWith(effect_1.Schema.ArrayEnsure(base_1.ConnectionState), {
        exact: true,
        default: () => [],
    }),
    operatingMode: effect_1.Schema.optionalWith(effect_1.Schema.ArrayEnsure(base_1.OperatingMode), {
        exact: true,
        default: () => [],
    }),
    installationStatus: effect_1.Schema.optionalWith(effect_1.Schema.ArrayEnsure(base_1.InstallationStatus), {
        exact: true,
        default: () => [],
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.OverviewPageQuery`,
    description: 'Query parameters for fetching fleet overview counters',
});
exports.OverviewPage = effect_1.Schema.Struct({
    tenantId: tenant_1.Id,
    lastUpdated: effect_1.Schema.optionalWith(date_1.DateFromUtcIsoDateString, { exact: true }),
    counters: FleetCounters.Counters,
}).annotations({
    identifier: `${exports.NAMESPACE}.OverviewPage`,
    description: 'Pre-calculated counters for fleet overview page',
});
//# sourceMappingURL=overview.js.map